import React from 'react';
import Img from '../../Img';

import styles from './checkBox.scss';

const CheckBox = (props) => (
    <div
        className={`${styles.checkBoxContainer} ${props.colClass ? props.colClass : ''} ${props.item.isSelected ? styles.selected : ''}`}
        onClick={() => {
            props.onChanged(props.item);
        }}
    >
        <div className={`${styles.checkIcon}`}>
            {props.item.isSelected && (
                <Img src="/img/check-mark.svg" />
            )}
        </div>
        <div className={`${styles.label} get-rated-label`}>
            {props.item.name}
        </div>
    </div>
);

export default CheckBox;
